import React from 'react';

import FAQs from 'common/www/Faqs';
import styles from 'css-module/components/www/_PricingV4.module.scss';

export default function PricingV4FAQs() {
  return (
    <div className={styles.pricingV4FAQs}>
      <FAQs
        faqs={[
          {
            question: 'What is a tracked user?',
            answer:
              '<p>A tracked user is someone who has given feedback. This can be via creating a post or voting/commenting on a post. Those actions can be taken by the user themselves, by an admin on their behalf, or by Autopilot.</p>',
            html: (
              <p>
                A tracked user is someone who has given feedback. This can be via creating a post or
                voting/commenting on a post. Those actions can be taken by the user themselves, by
                an admin on their behalf, or by Autopilot.
              </p>
            ),
          },
          {
            question: 'How many tracked users do I need?',
            answer:
              '<p>Fewer than you think. Most teams new to Canny find the Free plan’s 25 tracked users enough to start uncovering impactful feedback. Many teams use Canny for months before needing to upgrade to a paid plan. For a B2B SaaS company, around 5% of total users typically become tracked users. That should help you ballpark your needs. Running a high-volume B2C/consumer product? Reach out—we offer custom tracked-user limits for larger-scale feedback programs.</p>',
            id: 'how-many-tracked-users-do-i-need',
            html: (
              <>
                <p>
                  Fewer than you think. Most teams new to Canny find the Free plan’s 25 tracked
                  users enough to start uncovering impactful feedback. Many teams use Canny for
                  months before needing to upgrade to a paid plan.
                </p>
                <p>
                  For a B2B SaaS company, typically around 1-5% of total users become tracked users.
                  This will vary based on how proactive you are at collecting feedback.
                </p>
                <p>
                  Running a high-volume B2C/consumer product? Reach out-we offer custom tracked user
                  limits for larger scale feedback programs.
                </p>
              </>
            ),
          },
          {
            question: 'Can I set a monthly spend limit?',
            answer:
              '<p>Yes, you’re always in control. You can set a monthly spend limit, and we’ll pause upgrades once you hit it. We’ll notify you when you hit your limit.</p><p>Once your limit is hit, Canny will stop tracking feedback from new users. You can update or remove your limit anytime.</p>',
            html: (
              <>
                <p>
                  Yes, you’re always in control. You can set a monthly spend limit, and we’ll pause
                  upgrades once you hit it. We’ll notify you when you hit your limit.
                </p>
                <p>
                  Once your limit is hit, Canny will stop tracking feedback from new users. You can
                  update or remove your limit anytime.
                </p>
              </>
            ),
          },
          {
            question: 'What happens if I go over my tracked user limit?',
            answer:
              '<p>If you haven’t set a monthly spend limit, we’ll automatically upgrade you to the next tier once you exceed your limit. You’ll be charged a prorated amount for the remainder of your billing period.</p><p>If you’ve set a spend limit, we’ll stop tracking feedback from new users once you reach it—no surprises.</p>',
            html: (
              <>
                <p>
                  If you haven’t set a monthly spend limit, we’ll automatically upgrade you to the
                  next tier once you exceed your limit. You’ll be charged a prorated amount for the
                  remainder of your billing period.
                </p>
                <p>
                  If you’ve set a spend limit, we’ll stop tracking feedback from new users once you
                  reach it—no surprises.
                </p>
              </>
            ),
          },
          {
            question: 'What is Canny Autopilot?',
            answer:
              "<p>Autopilot refers to Canny's suite of AI-powered features:</p><p> Feedback Discovery: automatically captures feedback. It finds feedback in customer chats, sales calls, customer reviews, and more. Any detected duplicates are merged together. Users with feedback found by Autopilot count towards your tracked user count.</p><p>Smart Replies: Autopilot will automatically reply to Canny posts to collect more details.</p><p>Comment Summaries: instantly summarize comments to reveal the main themes.</p>",
            html: (
              <>
                <p>Autopilot refers to Canny's suite of AI-powered features:</p>
                <p>
                  Feedback Discovery: automatically captures feedback. It finds feedback in customer
                  chats, sales calls, customer reviews, and more. Any detected duplicates are merged
                  together. Users with feedback found by Autopilot count towards your tracked user
                  count.
                </p>
                <p>
                  Smart Replies: Autopilot will automatically reply to Canny posts to collect more
                  details.
                </p>
                <p>Comment Summaries: instantly summarize comments to reveal the main themes.</p>
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
